import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { FilterDataComponent } from '@emi/data-extraction/feature/filter-data';
import { clearFilters, clearSelections } from '@emi/shared/state/filters';
import * as Constants from '@emi/shared/constants';
import { GenericModalComponent } from 'libs/shared/ui/src/lib/generic-modal/generic-modal.component';

@Injectable()
export class FilterDataCanDeactivateGuard implements CanDeactivate<FilterDataComponent> {
    constructor(private dialog: MatDialog) {}
    async canDeactivate(
        component: FilterDataComponent,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Promise<boolean> {
        const showLeaveModal = JSON.parse(localStorage.getItem(component.modalType) ?? 'true');
        if (
            showLeaveModal &&
            component.selectionsApplied &&
            nextState.url !== `/${Constants.Routes.CONFIGURE_DATA_ROUTE}` &&
            nextState.url !== `/${Constants.Routes.SYSTEM_ERROR}`
        ) {
            const dialogRef = this.dialog.open(GenericModalComponent, {
                width: '340px',
                data: {
                    buttons: {
                        primary: 'Proceed',
                        secondary: 'Cancel',
                    },
                    content: 'Leaving will clear all your current selections, are you sure you want to leave?',
                    iconClass: 'fa-solid fa-triangle-exclamation',
                    title: 'Discard Current Selections',
                    type: component.modalType,
                    showUnderstoodCheckbox: true,
                },
            });

            return await dialogRef
                .afterClosed()
                .toPromise()
                .then((result) => {
                    if (result) {
                        component.store.dispatch(clearFilters());
                        component.store.dispatch(clearSelections());
                        return true;
                    }
                    return false;
                });
        }

        if (nextState.url === `/${Constants.Routes.CONFIGURE_DATA_ROUTE}`) {
            return true;
        }

        component.store.dispatch(clearFilters());
        component.store.dispatch(clearSelections());
        return true;
    }
}
